import { type FC, type HTMLAttributeAnchorTarget, type ReactElement } from 'react';
import { graphql, useFragment } from 'react-relay';
import { ProductImage } from './Carousel/ProductImage.tsx';
import {
    type ImageBackgroundColor,
    type OnClick,
    type SrcSet,
    type TileSize,
} from './constants.ts';

import dibsCss from 'dibs-css';

import { type BuyerProductImageOnly_item$key } from './__generated__/BuyerProductImageOnly_item.graphql.ts';

const itemFragment = graphql`
    fragment BuyerProductImageOnly_item on Item {
        ...ProductImage_item
        productPhotos: photos(limit: 1) {
            ...ProductImage_photo
        }
    }
`;

type Props = {
    item: BuyerProductImageOnly_item$key | null | undefined;
    buyerHost?: string;
    dataTn?: string;
    imageBackgroundColor?: ImageBackgroundColor;
    disableLinks?: boolean;
    imageLoadVerticalOffset?: number;
    imagePath?: string | null;
    index: number;
    itemsPerRow: number;
    linkTarget?: HTMLAttributeAnchorTarget;
    onClick?: OnClick;
    onContentLoaded?: () => void;
    size: TileSize;
    srcSet?: SrcSet;
    showSwipeIndicator?: boolean;
    favoritesComponent?: ReactElement;
};

export const BuyerProductImageOnly: FC<Props> = ({
    item: itemRef,
    buyerHost,
    dataTn,
    disableLinks,
    imageBackgroundColor,
    imageLoadVerticalOffset,
    imagePath,
    index,
    itemsPerRow,
    linkTarget,
    onClick,
    onContentLoaded,
    size,
    srcSet,
    favoritesComponent,
}) => {
    const item = useFragment(itemFragment, itemRef);
    const photos = item?.productPhotos?.[0];
    return (
        <article className={dibsCss.relative}>
            <ProductImage
                item={item}
                photo={photos}
                buyerHost={buyerHost}
                dataTn={dataTn}
                disableLinks={disableLinks}
                imageBackgroundColor={imageBackgroundColor}
                imageDraggable={false}
                imageLoadVerticalOffset={imageLoadVerticalOffset}
                imagePath={imagePath}
                isEagerImageLoadEnabled={index < itemsPerRow}
                hasVideo={false}
                linkTarget={linkTarget}
                onClick={onClick}
                onContentLoaded={onContentLoaded}
                size={size}
                srcSet={srcSet}
            />
            {favoritesComponent}
        </article>
    );
};
